import type { ISerialize } from '@/objects/ISerialize';

export class MergeParticipantsRequest implements ISerialize {
    public MasterID: number;

    public ParticipantIDIds: number[];

    public ParticipantIdsToMerge: number[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { MasterID?: number; ParticipantIDIds?: number[]; ParticipantIdsToMerge?: number[] }) {
        this.MasterID = values.MasterID ?? 0;

        this.ParticipantIDIds = values.ParticipantIDIds ?? [];

        this.ParticipantIdsToMerge = values.ParticipantIdsToMerge ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"MasterID": ${JSON.stringify(this.MasterID)}` +
            ',' +
            `"ParticipantIDIds": [ ${this.ParticipantIDIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"ParticipantIdsToMerge": [ ${this.ParticipantIdsToMerge.map((x) => JSON.stringify(x))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of MergeParticipantsRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        MasterID?: number;
        ParticipantIDIds?: number[];
        ParticipantIdsToMerge?: number[];
    }): MergeParticipantsRequest {
        return new MergeParticipantsRequest(values);
    }

    public static _FromServerJson(json: any): MergeParticipantsRequest {
        return new MergeParticipantsRequest({
            MasterID: json.MasterID,
            ParticipantIDIds: json.ParticipantIDIds,
            ParticipantIdsToMerge: json.ParticipantIdsToMerge,
        });
    }

    /**
     * Creates an instance of MergeParticipantsRequest from another instance of MergeParticipantsRequest.
     * @param other The MergeParticipantsRequest you want to clone
     * @returns A cloned MergeParticipantsRequest
     */
    public static FromOther(other: MergeParticipantsRequest): MergeParticipantsRequest {
        return MergeParticipantsRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return MergeParticipantsRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'MergeParticipantsRequest';
}
